export default {
  // API

  // ローカル
  information: "/lifeyell/info/${id}.json",
  getFavorites: "/v1/favorite/menu_item_info", // お気に入り一覧取得API
  getFreeUsage: "/v1/serviceusage/service_usage_status", // 無料期間表示API
  getUsageRegister: "/v1/serviceusage/service_usage_status_register",
  getUsageWithdrawal: "/v1/serviceusage/service_usage_status_withdrawal",
  getAgreeCheck: "/v1/stay/agreeterms/check", // 規約同意画面のON/OFF
  getTermsInformation: "/v1/stay/agreeterms/terms_information",
  getAgreeTermsProcess: "/v1/stay/agreeterms/process",
  getAgreeRegister: "/v1/stay/agreeterms/register",
  getAutoEntryStatus: "/v1/serviceusage/auto_entry_status",
  getAgreeTermsRegister: "/v1/serviceusage/agree_terms_register",
  getServiceUsage: "/v1/serviceusage/service_usage_status", // 無料期間表示API
  // ソフトバンクログイン画面URL取得API
  getSoftBankLoginPath: "/v1/stay/sb-login",
  // ソフトバンクログアウト処理API
  getSoftBankLogoutPath: "/v1/stay/sb-logout",
  // ユーザー個人情報取得
  postUser: "/v1/users/my",
  // ユーザー情報更新
  putUser: "/v1/users/member-info",
  // 契約情報取得
  postContractInfo: "/v1/users/contract-info",
  userPersist: "/v1/top/sb-user-regist",
  userWithdraw: "/v1/top/sb-user-withdraw",
  getNews: "/v1/cms/news" // お知らせ一覧取得API
};
